export interface EntryFieldMeta {
  id: string;
  name: string;
  type: string;
}

export interface EntryFieldsMetadata {
  fields: EntryFieldMeta[];
}

type EntryLike = { _metadata?: EntryFieldsMetadata } & Record<string, unknown>;

export const findEntryFieldByType = ({
  entry,
  type,
}: {
  entry?: unknown;
  type: string;
}): EntryFieldMeta | undefined => {
  const metadata = (entry as EntryLike | null | undefined)?._metadata;

  return metadata?.fields?.find((field) => field.type === type);
};

export const findEntryFieldsByType = ({
  entry,
  type,
}: {
  entry?: unknown;
  type: string;
}): EntryFieldMeta[] => {
  const metadata = (entry as EntryLike | null | undefined)?._metadata;

  return metadata?.fields?.filter((field) => field.type === type) ?? [];
};

export const readEntryFieldValueByType = ({
  entry,
  type,
}: {
  entry?: unknown;
  type: string;
}): unknown => {
  const field = findEntryFieldByType({ entry, type });
  if (!field) return undefined;

  return (entry as EntryLike)[field.name];
};
